import * as d3 from 'd3'
import * as d3Colection from 'd3-collection';
// import html2canvas from 'html2canvas';

import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { MatTooltip } from '@angular/material/tooltip';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ExportServiceService } from '@shared/services/export-service/export-service.service';


@Component({
  selector: 'donut-graph',
  templateUrl: './donut-graph.component.html'
})
export class DonutGraphComponent implements OnChanges, OnInit {
  idGraph: any = this.commonUtilsService.createId()
  skin: any = this.globalCfg.skin;
  donutGraph:any ={
    graphData: {},
    selectInfoTooltip:{},
    selectInfoTooltipPercent:'0%',
    selectInfoTooltipRiskList:[]
  }
  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private container: ElementRef,
    private commonUtilsService: CommonUtilsService,
    private loader: LoaderFactory,
    private exportService: ExportServiceService) { }

  @Input() configurateReport: any =  null;
  @Input() graphData: any =  null;
  @Input() from: any =  null;
  @Input() id: any =  '';

  ngOnInit(): void {
    if(this.configurateReport.type === 'risk'){
      this.clickOffDonut();
    }
  }
  ngOnChanges(): void {
    this.donutGraph.graphData = this.graphData;
    if(this.graphData && this.graphData.colors.length){
        if(!this.donutGraph.graphData.graphicId){
            this.donutGraph.graphData.graphicId = 0;
        }
        if($(`#${this.idGraph}`).children().length){
          $(`#${this.idGraph}`).children().remove();
        }
        this.drawSvg();
    }
  }

  clickOffDonut(){
    $(document).off('click', (event)=>{this.closeRichTooltip(event)});
    $(document).on('click', (event)=>{this.closeRichTooltip(event)});
  }

  closeRichTooltip(event:any){
    if(event.target.id.indexOf('arc-value-'+this.idGraph) === -1 && (typeof event.target.className !== 'string' || event.target?.className?.indexOf('common-tooltip-info') === -1) && (typeof event.target.offsetParent?.className !== 'string' || event.target.offsetParent?.className?.indexOf('common-tooltip-info') === -1)){
      this.closeRiskTooltip('');
    }
  }


  drawSvg(){
    let widthHeight = 280;
    let innerRadius = 80;
    let outerRadius = 132;
    if(this.configurateReport.type === 'poll' || this.configurateReport.type === 'be' || this.configurateReport.type === 'risk'){
      widthHeight = 364;
      innerRadius = 104;
      outerRadius = 171.6;
    }
    this.donutGraph.graph = {
        width: widthHeight,
        height: widthHeight,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
    }

    this.createSvg();

    if(this.configurateReport.type === 'poll' || this.configurateReport.type === 'be'){
        this.donutGraph.graph.innerRadiusOut = outerRadius + 4;
        this.donutGraph.graph.outerRadiusOut = this.donutGraph.graph.innerRadiusOut + 4;
        if(this.configurateReport.type === 'poll'){
            this.createDonutHover();
        }
    }
    this.createDonut();
  }

  createDonut(){
    let amountPercentage = 0;
    this.donutGraph.graphData.pie = d3.pie()
        .value((d:any)=> { return d.value; })

    this.donutGraph.graphData.pieData = this.donutGraph.graphData.pie(d3Colection.entries(this.donutGraph.graphData.data));
    let gElement: any = this.donutGraph.graph.g.selectAll('donut-graph__split-pie-container')
      .data(this.donutGraph.graphData.pieData);

    let gSplitPie:any =  gElement.enter()
      .append('g')
      .attr('class', 'donut-graph__split-pie-container')
      .attr('id', (d:any)=>{return `group-arc-value-${this.idGraph}-${d.data.key}`});
      if(this.configurateReport.type === 'be'){
        gSplitPie
        .append('path')
        .attr('id', (d:any) => { return `path-arc-value-${this.idGraph}-${d.data.key}`})
        .attr('d',
            d3.arc()
                .innerRadius(this.donutGraph.graph.innerRadius)
                .outerRadius(this.donutGraph.graph.outerRadius+2)

        )
        .style('fill','#F7F7F3');
      }

      if(this.configurateReport.type ==='risk'){
        gSplitPie
          .on('click', (ev:any, d:any) => this.mouseover(d));
      }else if(this.configurateReport.type === 'poll' || this.configurateReport.type === 'be'){
        gSplitPie
          .on('mouseover', (ev:any, d:any) => this.mouseover(d))
          .on('mouseout', (ev:any, d:any) => this.mouseout(d));
      }


      gSplitPie
        .append('path')
        .attr('class',()=>{ return this.configurateReport.type === 'risk'? 'donut-graph__arc-pointer':''})
        .attr('id', (d:any) => { return `path-arc-value-${this.idGraph}-${d.data.key}`})
        .attr('d',
            d3.arc()
                .innerRadius(this.donutGraph.graph.innerRadius)
                .outerRadius(this.donutGraph.graph.outerRadius)
        )
        .style('fill', (d:any)=>{ return(this.donutGraph.graphData.colors[d.data.key]) })
      gSplitPie
        .append('text')
        .attr('id', (d:any)=>{return `arc-value-${this.idGraph}-${d.data.key}`})
        .attr('class', 'donut-graph__arc-value')
        .attr("transform", (d:any) => {
            let arcCenter = (d3.arc().innerRadius(this.donutGraph.graph.innerRadius).outerRadius(this.donutGraph.graph.outerRadius)).centroid(d)
            return "translate(" +(arcCenter)  + ")";
        })
        .style('text-anchor', 'middle')
        .text((d:any)=>{
            if(d.value){
                let percentageReturn = '';
                let percentage = (d.value * 100)/ this.donutGraph.graphData.amount;
                let amount = amountPercentage + Math.round((d.value * 100)/ this.donutGraph.graphData.amount);
                if(amount > 100){
                    amountPercentage += Math.floor((d.value * 100)/ this.donutGraph.graphData.amount);
                    percentageReturn = (Math.round(percentage * 10) / 10).toFixed(1) + '%';
                }else{
                    amountPercentage += Math.round((d.value * 100)/ this.donutGraph.graphData.amount);
                    percentageReturn = (Math.round(percentage * 10) / 10).toFixed(1) + '%';
                }
                if(percentage >= 5){
                  return percentageReturn;
                }
            }
            return '';

        })
  }

  createSvg(){
      this.donutGraph.graph.svg = d3.select(this.container.nativeElement.firstChild.firstChild)
        .append('svg')
        .attr('id', ()=>{
            return this.configurateReport.type === 'poll'? 'bar-graph__donut-block-'+ this.donutGraph.graphData.graphicId : 'bar-graph__donut-block'
        })
        .attr("width", this.donutGraph.graph.width)
        .attr("height", this.donutGraph.graph.height);
        // .attr("viewBox", `0 0 ${this.donutGraph.graph.width} ${this.donutGraph.graph.height}`);


      this.donutGraph.graph.g = this.donutGraph.graph.svg.append('g')
        .attr('class', 'donut-graph__donut-graph-container')
        .attr('id', `donut-graph-container-${this.idGraph}`)
        .attr("transform", "translate(" + this.donutGraph.graph.width / 2 + "," + this.donutGraph.graph.height / 2 + ")");

      if(!(this.configurateReport.type === 1 && this.configurateReport.subType === 2)){
        let area: any = this.from === 'report-table'? 161 : 207;
        let translate: any = this.from === 'report-table'? -80 : -102
        this.donutGraph.graph.g
          .append('foreignObject')
          .attr("x", translate)
          .attr("width", area)
          .attr("y", translate)
          .attr("height", area)
          .append('xhtml:div')
          .attr('id', `info-donut-${this.idGraph}-${this.donutGraph.graphData.graphicId}`)
          .attr('class', ()=>{
            let className: string = 'donut-graph__info-donut';
            if(this.configurateReport.type !== 'be' && this.configurateReport.type !== 'poll'){
              className += ' donut-graph__info-donut--graph'
            }
            return className;
          })
          .append('span')
          .attr('class', 'donut-graph__value-title')
          .text(this.donutGraph.graphData.graphicCaption);

        d3.select(`#info-donut-${this.idGraph}-${this.donutGraph.graphData.graphicId}`)
          .append('span')
          .attr('class', ()=>{
            let className:string = 'donut-graph__value-text';
            if(this.configurateReport.type !== 'be' && this.configurateReport.type !== 'poll'){
              className += ' donut-graph__value-text--graph';
            }
            return className;
          })
          .text(this.donutGraph.graphData.amount);
      }
  }

  mouseover(d:any){
    switch(this.configurateReport.type){
      case 'risk':
        // this.selectAndShowRiskTooltip(d, 140);
        // break;
      case 'poll':
      case 'be':
        this.showTooltip(d);
        break;
    }
  }

  showTooltip(d:any){
    if(!(this.donutGraph.showTooltipInfo && d.data.key === this.donutGraph.tooltipInfoKey)){
      let widthTooltip: number = 85;
      if(this.configurateReport.type === 'risk'){
        widthTooltip = 140;
        let selectByColor:any = this.donutGraph.graphData.colors[d.data.key]
        this.donutGraph.selectInfoTooltip = this.donutGraph.graphData.original.filter((item:any)=>{ return item.color === selectByColor})[0]
        this.donutGraph.selectInfoTooltipPercent = `(${Math.round(this.donutGraph.selectInfoTooltip.count * 100 /this.donutGraph.graphData.amount)} %)`;
        this.donutGraph.selectInfoTooltipRiskList = this.donutGraph.selectInfoTooltip.riesgos.indexOf('|') !== -1? this.donutGraph.selectInfoTooltip.riesgos.split('|') : [this.donutGraph.selectInfoTooltip.riesgos]
      }else{
        let valueTooltip = this.donutGraph.graphData.legend[parseInt(d.data.key)];
        if(this.configurateReport.numericalScale){
          valueTooltip = this.translate.instant('common.punctuation') + ' ' + valueTooltip;
        }
        d3.select(`#donut-graph-tooltip-text-${this.idGraph}`)
          .text(valueTooltip);
      }

      let tooltipPosition: any = this.configurePositionTooltip(d, widthTooltip);
      d3.select(`#donut-graph-tooltip-${this.idGraph}`)
        .style('left', `${tooltipPosition.offsetX}px`)
        .style('top', `${tooltipPosition.offsetY}px`)
        .style('visibility', 'visible');

      if(this.configurateReport.type === 'poll'){
          d3.select('#bar-graph__portion-out-'+d.data.key+'-'+ this.donutGraph.graphData.graphicId).style("opacity", 0.5);
      }
    }
  }

  configurePositionTooltip(d: any, widthTooltip: number = 140){
    let element: any = document.getElementById(`arc-value-${this.idGraph}-${d.data.key}`);
    let clientRect = element.getBoundingClientRect();
    let clientText = { clientX: clientRect.left, clientY: clientRect.top};
    let offsetX =  d3.pointer(clientText, this.donutGraph.graph.svg.node())[0] - (widthTooltip - (clientRect.width/2));
    let offsetY =  d3.pointer(clientText, this.donutGraph.graph.svg.node())[1] + 25;
    return { offsetX: offsetX, offsetY: offsetY };
  }

  mouseout(d:any, type:string=''){
    switch(this.configurateReport.type){
      case 'risk':
        break;
      case 'poll':
      case 'be':
        this.closeRiskTooltip('');
        d3.select('#bar-graph__portion-out-'+d.data.key+'-'+ this.donutGraph.graphData.graphicId).style("opacity", 0);
        break;
    }
  }

  closeRiskTooltip(type:string){
    d3.select(`#donut-graph-tooltip-${this.idGraph}`)
      .style('visibility','hidden');
  }

  createDonutHover(){
    this.donutGraph.graphData.pie = d3.pie()
        .value((d:any)=>{ return d.value; })
    this.donutGraph.graphData.pieData = this.donutGraph.graphData.pie(d3Colection.entries(this.donutGraph.graphData.data))

    this.donutGraph.graph.g.selectAll()
        .data(this.donutGraph.graphData.pieData)
        .enter()
        .append('path')
        .attr('id', (d:any)=>{
            return 'bar-graph__portion-out-'+d.data.key+'-'+ this.donutGraph.graphData.graphicId;
        })
        .attr('d',
            d3.arc()
                .innerRadius(this.donutGraph.graph.innerRadiusOut)
                .outerRadius(this.donutGraph.graph.outerRadiusOut)
        )
        .style("opacity", 0)
        .style('fill', (d:any)=>{ return this.donutGraph.graphData.colors[d.data.key] });
  }

  saveAsPng(tooltip: MatTooltip){
    let documentObject:any = document;
    // let that = this;
    // that.donutGraph.disabledSaveAsPng = true;
    tooltip.hide();
    let config: any = {
      documentPrint: documentObject.querySelector('.donut-graph'),
      name: 'Captura',
      successCallback: (uploadResponse:any, blob:any) => {
        let dataBlob = new Blob([blob], { type: 'image/png' });
        let data = [new ClipboardItem({ [dataBlob.type]: dataBlob })];
        navigator.clipboard.write(data)
            .then(() => {}, (err) => console.log(err));
        this.loader.closeLoader(['export-file']);
        // that.donutGraph.disabledSaveAsPng = false;
        tooltip.message = this.translate.instant('results-report.image-captured');
        tooltip.show();
        setTimeout(() => {
          tooltip.hide();
        }, 1500);
        setTimeout(() => {
          tooltip.message = this.translate.instant('results-report.capture-image');
        }, 1700);
      }
    };
    this.exportService.convertToImg(config);
  }

  // saveAsPng(tooltip: MatTooltip){
  //   let documentObject:any = document;
  //   let that = this;
  //   that.donutGraph.disabledSaveAsPng = true;
  //   tooltip.hide();
  //   setTimeout(() => {
  //     html2canvas(documentObject.querySelector(".donut-graph"))
  //     .then(function(canvas) {
  //         canvas.toBlob((blob:any)=>{
  //             let data = [new ClipboardItem({ [blob.type]: blob })];
  //             navigator.clipboard.write(data)
  //                 .then(() => {}, (err) => {});
  //         });
  //     }).then(() => {
  //       that.donutGraph.disabledSaveAsPng = false;
  //       tooltip.message = this.translate.instant('results-report.image-captured');
  //       tooltip.show();
  //       setTimeout(() => {
  //         tooltip.message = this.translate.instant('results-report.capture-image');
  //         tooltip.hide();
  //       }, 2000);
  //     });
  //   }, 100);
  // }

}
